import axios from 'axios';
import { getLoggedInServiceNo } from '../utils/masterDataUtils';

// ── Helpers ────────────────────────────────────────────────────────────────
const val = (v) => (v === null || v === undefined ? '' : String(v).trim());

/** "15:00" → "15:00:00" */
const toHms = (t) => {
  const s = val(t);
  if (!s) return '';
  return s.length === 5 ? `${s}:00` : s;
};

// ─────────────────────────────────────────────────────────────────────────
//  PAYROLL PERIODS
// ─────────────────────────────────────────────────────────────────────────
// const GetPayrollPeriods = async () => {
//   const response = await axios.get('PayRoll/GetPayRollPeriod');
//   return response;
// };

// ─────────────────────────────────────────────────────────────────────────
//  OT CRUD
// ─────────────────────────────────────────────────────────────────────────

/**
 * Add Overtime
 * POST OT/AddOvertime?p_employeeId=...&p_payrollPeriodId=...&...
 * NOTE: no p_isApproved / p_approvedBy — approval handled elsewhere
 */
const AddOvertime = (payload) => {
  return axios.post('OT/AddOvertime', null, {
    params: {
      p_employeeId:      payload.employeeId,
      // p_payrollPeriodId: payload.payrollPeriodId,
      p_otDate:          payload.otDate,
      p_otType:          payload.otType,
      p_startTime:       toHms(payload.startTime),
      p_endTime:         toHms(payload.endTime),
      p_totalHours:      Number(payload.totalHours) || 0,
      p_otRate:          Number(payload.otRate) || 0,     
      p_OTHRate:         Number(payload.othRate) || 0,    
      p_otAmount:        Number(payload.otAmount) || 0,
      p_adjHours:        Number(payload.adjHours) || 0, 
      p_createdBy:       payload.createdBy ?? getLoggedInServiceNo() ?? 'SYSTEM',
      p_isActive:        1,
    },
  });
};

/**
 * Update Overtime
 * POST OT/UpdateOvertime?p_overtimeId=...&...
 * NOTE: no p_isApproved / p_approvedBy — approval handled elsewhere
 */
const UpdateOvertime = (payload) => {
  const params = {
    p_overtimeId:      payload.overtimeId,
    p_employeeId:      payload.employeeId,
    // p_payrollPeriodId: payload.payrollPeriodId,
    p_otDate:          payload.otDate,
    p_otType:          payload.otType,
    p_startTime:       toHms(payload.startTime),
    p_endTime:         toHms(payload.endTime),
    p_totalHours:      Number(payload.totalHours) || 0,
    p_otRate:          Number(payload.otRate) || 0,
    p_otAmount:        Number(payload.otAmount) || 0,
    p_createdBy:       payload.createdBy ?? getLoggedInServiceNo() ?? 'SYSTEM',
    p_isActive:        payload.isActive ? 1 : 0,
  };

  // Only send payrollId when it actually exists
  // if (
  //   payload.payrollId !== undefined &&
  //   payload.payrollId !== null &&
  //   String(payload.payrollId).trim() !== ''
  // ) {
  //   params.p_payrollId = payload.payrollId;
  // }

  return axios.post('OT/UpdateOvertime', null, { params });
};

/** Fetch OT by id — used to pre-fill edit mode */
const GetOvertimeById = (overtimeId) => {
  return axios.get('OT/GetOvertimeById', {
    params: { p_overtimeId: overtimeId },
  });
};

/** One employee's record (EMP/GetEmployeebyID) — used for HED_OT_RATE. */
const GetEmployeeById = (employeeId) => {
  return axios.get('EMP/GetEmployeebyID', {
    params: { p_hedEmployeeId: employeeId },
  });
};

/** Fetch Overtime list */
const GetOvertimeList = () => {
  return axios.get('OT/GetOvertime');
};

// ─────────────────────────────────────────────────────────────────────────
//  EXPORT
// ─────────────────────────────────────────────────────────────────────────
const OTEntryService = {
  // GetPayrollPeriods,
  AddOvertime,
  UpdateOvertime,
  GetEmployeeById,
  GetOvertimeById,
  GetOvertimeList,
};

export default OTEntryService;